var lightboxFactory = require('ub/lp/editor/lightbox-factory');

window.lp.editor = window.lp.editor || {};

/*
  This is a hack to support AMP pages. They are published by a lambda which runs after
  lp-publisher, which puts the file amp.html in the page's S3 bucket. To ensure that PS2 flushes
  its cache for this file after a republish, we add an unlinked subpage whose path_name is amp.html.
*/
window.lp.editor.addAmpLightbox = function addAmpLightbox() {
  if (window.editor.page.settings.contentType !== 'amp') {
    return;
  }

  var existingLightbox = window.editor.pages.filter(p => p.page.used_as === 'lightbox')[0];
  var lightbox = existingLightbox || lightboxFactory.createLightbox(window.editor);

  lightbox.page.path_name = 'amp.html';

  if (!existingLightbox) {
    window.editor.addPage(lightbox);
  }
};



// WEBPACK FOOTER //
// ./src/lp/editor/add-amp-lightbox.js